import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { AuthStateService } from '../../core/services/auth-state/auth-state-service.service';
@Component({
  selector: 'app-setting',
  standalone: true,
  imports: [CommonModule, RouterOutlet,RouterLink, TranslateModule],

  templateUrl: './setting.component.html',
  styleUrl: './setting.component.css',
})
export class SettingComponent {
  botones = ['settings.buttons.general'];
  botonSeleccionado = 0;
  opt = false;
  isSupplier = false;

  constructor(private authStateService: AuthStateService) {
    this.isSupplier = this.authStateService.getAccountType() === 'supplier';
  }

  seleccionarBoton(index: number) {
    this.botonSeleccionado = index;
    this.opt = false;
  }

  changeOpt() {
    this.opt = !this.opt;
  }
}
